export function shouldShowLiveRunWaitCountdown(params: {
  hasWaitingStep: boolean;
  isLiveRunning: boolean;
  countdownComplete: boolean;
  countdownResuming: boolean;
}): boolean {
  if (!params.hasWaitingStep) return false;
  if (!params.isLiveRunning) return true;

  return !params.countdownComplete || params.countdownResuming;
}
